export const inventoryColumns = [
  {
    field: "actions",
    type: "actions",
    headerName: "Actions",
    width: 80,
    cellClassName: "actions",
  },
  {
    field: "fromWarehouseCode",
    headerName: "From Warehouse Code",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 130,
  },
  {
    field: "zoneID",
    headerName: "From Zone ID",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 130,
  },
  {
    field: "locationID",
    headerName: "From Location ID",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 130,
  },
  {
    field: "warehouseCode",
    headerName: "To Warehouse Code",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 130,
  },
  {
    field: "toZone",
    headerName: "To Zone ID",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 130,
  },
  {
    field: "toLocation",
    headerName: "To Location ID",
    sortable: false,
    align: "left",
    flex: 1.6,
    minWidth: 160,
  },
  {
    field: "skuCode",
    headerName: "SKU Code",
    sortable: false,
    align: "left",
    flex: 1.8,
    minWidth: 180,
  },
  {
    field: "quantity",
    headerName: "Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "quantityAvailable",
    headerName: "Quantity Available",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    headerAlign: 'right',
  },
  {
    field: "transferQuantity",
    headerName: "Transfer Quantity",
    sortable: false,
    align: "right",
    flex: 1,
    minWidth: 100,
    type: 'number',
  },
  {
    field: "baseUOM",
    headerName: "Base UOM",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "palletNbr",
    headerName: "Pallet Nbr",
    sortable: false,
    align: "left",
    flex: 1.2,
    minWidth: 112,
  },
  {
    field: "toPallet",
    headerName: "To Pallet",
    sortable: false,
    align: "left",
    flex: 1.3,
    minWidth: 125,
  },
  {
    field: "cartonID",
    headerName: "Carton ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "toCartonID",
    headerName: "To Carton ID",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "mln",
    headerName: "MLN",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "toMLN",
    headerName: "To MLN",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "expiryDate",
    headerName: "Expiry Date",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 130,
  },
  {
    field: "toExpiryDate",
    headerName: "To Expiry Date",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 190,
    type: 'date',
  },
  {
    field: "vendorCode",
    headerName: "Vendor Code",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 120,
  },
  {
    field: "packType",
    headerName: "Pack Type",
    sortable: false,
    align: "left",
    flex: 1,
    minWidth: 100,
  },
  {
    field: "oln",
    headerName: "OLN",
    sortable: false,
    align: "left",
    flex: 1.2,
    minWidth: 112,
  },
];